import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const StatsModalLazy = React.lazy(() =>
  import('./StatsModal').then((m) => ({ default: m.StatsModal })),
);

NiceModal.register(
  MODALS.STATS,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <StatsModalLazy />
    </Suspense>
  )),
);
